import { Component, ElementRef, ViewChild, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service'; import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs'; import { MessageService } from 'primeng/api'; 
import { PedidosService } from 'src/app/services/pedidos.service'; import { PushService } from 'src/app/services/push.service';
import { AvatarService } from 'src/app/services/avatar.service'; import { BadgeCountService } from 'src/app/services/badge-count.service';  // 
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit, OnDestroy {

    breadcrumb!: string;
    @ViewChild('menubutton') menuButton!: ElementRef;

    avatarUrl: string | null = null;
    private avatarSubscription!: Subscription;

    constructor(
        public layoutService: LayoutService,
        private badgeCountService: BadgeCountService,
        private errorHandler: ErrorHandlerService,
        private pushService: PushService,
        private messageService: MessageService,
        private activatedRoute: ActivatedRoute,
        private cdRef: ChangeDetectorRef,
        private avatarService: AvatarService,
        private pedidosService: PedidosService,
        private router: Router
    ) { }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }
    isMobile: boolean = false;
    isLoading: boolean = true;
    checkIfMobile() {
        this.isMobile = window.innerWidth <= 768;
    }
    pushsNaoLidos = 0;
    commentsNaoLidos = 0;

    get pushsNaoLidosLabel(): string {
        return this.pushsNaoLidos > 9 ? '9+' : this.pushsNaoLidos.toString();
    }

    get commentsNaoLidosLabel(): string {
        return this.commentsNaoLidos > 9 ? '9+' : this.commentsNaoLidos.toString();
    }

    ngOnInit() {
        this.checkIfMobile();
        let user_id = localStorage.getItem('user_id');
        if (user_id === null) {
            console.error('User ID is not available in localStorage');
            // Você pode tratar esse caso como achar melhor
            this.isLoading = false;
        } else {
            let numericUserId = parseInt(user_id, 10);
            this.pedidosService.getCachedUserDetail(numericUserId, true).subscribe({
                next: (response: any) => {

                    if (response.photo) {
                        this.avatarUrl = response.photo.split('?')[0];
                        localStorage.setItem('avatarUrl', this.avatarUrl || '');
                    } else {
                        this.avatarUrl = 'assets/layout/images/avatar.png';  // Imagem padrão se `null`
                        localStorage.setItem('avatarUrl', this.avatarUrl);
                    }
                    this.isLoading = false;
                },
                error: (error: any) => {
                    this.isLoading = false;
                    this.errorHandler.handle(error);
                }
            });
        }

        this.avatarSubscription = this.avatarService.avatar$.subscribe(avatar => {
            this.avatarUrl = avatar;
        });


        const userId = parseInt(localStorage.getItem('user_id') || '0', 10);
        if (!userId) return;

        //this.pedidosService.refreshUnreadPushCount(userId); // faz a primeira carga
        this.badgeCountService.getUnreadPushCountObservable().subscribe(count => {
            this.pushsNaoLidos = count;
            this.cdRef.detectChanges();
        });
        this.badgeCountService.getUnreadCommentsCountObservable().subscribe(count => {
            console.log('valor chat que chegou para setar')
            console.log(count)
            this.commentsNaoLidos = count;
            this.cdRef.detectChanges();
        });
        this.pushService.newPush$.subscribe((notification) => {
            if (notification) {
                // Incrementa localmente a contagem
                this.pushsNaoLidos++;
                this.cdRef.detectChanges();
                const userId = Number(localStorage.getItem('user_id') || '0');
                if (userId) {
                    this.pedidosService.refreshUnreadPushCount(userId);
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.avatarSubscription) {
            this.avatarSubscription.unsubscribe();
        }
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }
    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }
    onChatButtonClick() {
        // Na rota slick/:uuid o botão de chat do header deve abrir direto a
        // conversa daquele slick, pulando a lista de Comentários. SlickDetailComponent
        // publica esse contexto assim que os dados do slick terminam de carregar.
        const ctx = this.layoutService.currentSlickChatContext;
        if (ctx) {
            // Precisa alternar (abrir/fechar) igual ao showChatSidebar() abaixo —
            // openDirectChat() sozinho só abre, nunca fecha; directChatVisible
            // é quem sabe se a conversa direta já está na tela.
            if (this.layoutService.state.directChatVisible) {
                this.layoutService.closeDirectChat();
            } else {
                this.layoutService.openDirectChat(ctx.uuid, ctx.description, ctx.thumbnail);
            }
            return;
        }
        this.layoutService.showChatSidebar();
    }
}